import React, { Component } from 'react';
import styled from 'styled-components';

import { ContentBlock, ContentSection, PageHeader } from './components';
import ResetPasswordFormContainer from '../user/components/ResetPasswordFormContainer';
import colorThemes from '../../ui/colorThemes';

const StyledPage = styled.div`
	> header {
		text-align: center;
    margin-top: 3rem;
    margin-bottom: 10rem;
	}

	form {
		max-width: 370px;
		margin: 0 auto;
	}
`;

class ResetPasswordPage extends Component {

  render() {
    return (
			<ContentBlock theme={colorThemes.TRANSPARENT}>
        <StyledPage>
          <PageHeader title="Vaihda salasana" />
          <ContentSection>
            <ResetPasswordFormContainer />
          </ContentSection>
        </StyledPage>
      </ContentBlock>
    );
  }
};

export default ResetPasswordPage;


// WEBPACK FOOTER //
// ./src/modules/pages/ResetPasswordPage.js